import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 19,
  steps: [
    addColumns({
      table: 'chats',
      columns: [
        { name: 'session_id', type: 'number', isIndexed: true },
        { name: 'connection_key', type: 'string', isIndexed: true },
        { name: 'phone_number', type: 'string', isIndexed: true }
      ]
    }),
    addColumns({
      table: 'messages',
      columns: [{ name: 'message_id', type: 'string', isIndexed: true }]
    })
  ]
}
